import React, { Component } from 'react';

class IconSidebarParentTicketList extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="26"
                fill="none"
                viewBox="0 0 24 26"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#fff"}
                    d="M13.884 11.462h6.814c.64 0 1.134.366 1.27.94.174.751-.379 1.437-1.203 1.484H7.108c-.63 0-1.114-.3-1.289-.799-.271-.808.31-1.625 1.192-1.625 1.445-.01 2.889 0 4.333 0h2.54zM13.264 6.004h6.194c.63 0 1.124.367 1.27.921.193.742-.369 1.456-1.173 1.494H7.109c-.61 0-1.095-.3-1.27-.799-.29-.789.291-1.606 1.173-1.616.97-.01 1.939 0 2.908 0h3.344zM11.073 16.91c1.357 0 2.705-.01 4.062 0 .727 0 1.28.582 1.24 1.278-.038.658-.59 1.146-1.328 1.146H7.08c-.688 0-1.202-.413-1.299-1.024-.116-.733.436-1.39 1.212-1.4 1.211-.01 2.423 0 3.634 0h.446zM4.5 7.254c.01.639-.562 1.155-1.288 1.184-.485.01-1.192-.451-1.211-1.09-.02-.752.513-1.325 1.23-1.344.698-.01 1.26.536 1.27 1.25zM4.5 12.683c.068.564-.552 1.212-1.143 1.203-.775-.01-1.367-.536-1.357-1.231.01-.648.591-1.203 1.26-1.194.717 0 1.298.649 1.24 1.222zM4.501 18.14c.068.508-.504 1.203-1.153 1.194C2.582 19.324 2 18.798 2 18.122c0-.649.572-1.203 1.25-1.203.717-.01 1.318.639 1.25 1.222z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarParentTicketList;